import { _js } from '@ifixit/localize';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo, faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { tiptapButtonStyle } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';
import {
   Menu,
   MenuButton,
   MenuList,
   MenuItem,
   IconButton,
   Tooltip,
   HStack,
} from '@chakra-ui/react';
import { noteTypes } from '@ifixit/wiki-components/wiki-note';

const headings = {
   note: _js('Note'),
   tip: _js('Tip'),
   important: _js('Important'),
   warning: _js('Warning'),
   caution: _js('Caution'),
};

export function NoteDropdown() {
   const { editor } = useEditorContext();

   return (
      <Menu onClose={() => setTimeout(() => editor.commands.focus(), 50)}>
         <Tooltip placement="top-start" label={_js('Insert a note')}>
            <MenuButton
               as={IconButton}
               isDisabled={!editor.can().toggleNote('note')}
               icon={
                  <HStack spacing="7px">
                     <FontAwesomeIcon icon={faCircleInfo} />
                     <FontAwesomeIcon icon={faChevronDown} />
                  </HStack>
               }
               padding={1}
               {...tiptapButtonStyle}
               {...(editor.isActive('note') && { bgColor: 'gray.200' })}
            />
         </Tooltip>
         <MenuList>
            {noteTypes.map(type => {
               const isCurrentType = editor.isActive('note', { type });
               const onClickHandler =
                  !isCurrentType && editor.isActive('note')
                     ? () => editor.chain().focus().setNoteType(type).run()
                     : () => editor.chain().focus().toggleNote(type).run();
               return (
                  <MenuItem key={type} onClick={onClickHandler}>
                     {headings[type]}
                  </MenuItem>
               );
            })}
         </MenuList>
      </Menu>
   );
}
